import { faChevronDown, faChevronUp } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

type CollapsibleSectionProps = {
  count: number;
  title: string;
  children: React.ReactNode;
}

function CollapsibleSection({ count, title, children } : CollapsibleSectionProps) {
  const [isOpen, setIsOpen] = React.useState(true);

  return (
    <div className="mb-2 mx-1 panel panel-default">
      <div
        className="panel-heading"
        style={{ cursor: 'pointer' }}
        onClick={() => setIsOpen(!isOpen)}
      >
        <div className="info-well text-center mb-2">
          <h3 className="mb-0">{title} ({count})</h3>
          <FontAwesomeIcon icon={isOpen ? faChevronDown : faChevronUp} />
        </div>
      </div>
      {isOpen && (
        <div className="p-2 panel-body">
          {children}
        </div>
      )}
    </div>
  );
}

export default CollapsibleSection;
